import HelpDialog from "./HelpDialog.vue";

var helpControlsInitialized = false;

function initializeHelpDialog() {
  if (!helpControlsInitialized) {
    var ctrls = [HelpDialog];
    ctrls.forEach((component) => {
      const componentInstance = new Vue({
        ...component,
        propsData: {
          mode: null,
          patientId: vueApp.patientId,
          patientFirstName: vueApp.patientFirstName,
          patientLastName: vueApp.patientLastName,
          isAnonymized: vueApp.isAnonymized,
          versions: vueApp.versions,
          appVersion: vueApp.appVersion
        },
      });
      const vueContainer = document.createElement("div");
      document.getElementById("main_div").appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });
    console.log("HelpDialog initialized");
    helpControlsInitialized = true;
  }
}

function showHelpDialog() {
  initializeHelpDialog();
  $("#helpDialog").modal();
}

export { initializeHelpDialog, showHelpDialog };
